import { markRaw } from 'vue';
import { ManifoldBridgeProvider } from '@manifoldxyz/manifold-provider-client';
import { NETWORK_ID } from '@/common/constants';

export function getManifoldBridgeProvider () : ManifoldBridgeProvider {
  return markRaw(new ManifoldBridgeProvider(window.ManifoldEthereumProvider.network() ?? NETWORK_ID));
}
